export default __webpack_public_path__ + "static/media/logo.e41f6087.svg";